/**
 * React Query keys are cached per business: the open business, or (in All
 * businesses mode) the business a page is showing. Account-level data (the
 * business list, permissions — which carry their own business —, plan,
 * prices) is the same whatever is open.
 */
import { hashKey, type QueryKey } from "@tanstack/react-query";
import useBusinessStore from "@/stores/businessStore";

const UNSCOPED_KEYS = new Set(["businesses", "businesses-mine-for-active", "permissions", "entitlements", "public-plans", "enterprise", "team-chat-available", "auth", "profile", "fx-rates", "public", "pay-link"]);

export function businessScopedHash(key: QueryKey): string {
  if (typeof key[0] === "string" && UNSCOPED_KEYS.has(key[0])) return hashKey(key);
  const b = useBusinessStore.getState();
  const scope = b.activeBusinessId || b.activeBusinessSlug || (b.pageBusinessId ? `page:${b.pageBusinessId}` : "all");
  return hashKey([...key, `@${scope}`]);
}
